module.exports = __webpack_public_path__ + "static/media/yep-popup-2023.2636ff00.png";